import { Injectable } from "@angular/core";
import { ApiOauthService, ApiService, ApiWpService } from "@mare-common/ngx-mare-auth";
import { CompanyInterface, UserInterface } from "@mare-common/ngx-mare-user";
// import { ApiOauthService } from "@mare-common/ngx-mare-auth";
import { BehaviorSubject, Observable, ReplaySubject, Subject, catchError, take, } from "rxjs";
// import { environment } from "src/environments/environment";
import { PlatformApiWpService } from "./platform-apiwp.service";
import { TokenService } from "./token.service";
import { ChartConfigService } from "./chart-config.service";
import { CommonConfig } from "../shared/common-config/common-config";
import { UrlTree } from "@angular/router";

export interface CompanyInterfaceExtended extends CompanyInterface {
  company_meta?: any;
  delfi_offers?: any;
  delfi_report_max_requestes?: number | string;
  delfi_report_requests?: number | string;
  eureso_overview?: any;
  profitLost?:string | number
}

export interface CompanyFinancialStatements {
  ebitda: number,
  fatturatoAzienda: number,
  fatturatoMedio: number,
  profittabilitaAzienda: number,
  profittabilitaMercato: number,
  utilePerso: number,
  chartconfig: any
}

@Injectable({
    providedIn: 'root'
})
export class UserCompanyService {
  
    retriveUserCompanyPromise: Promise<any> | null = null;
    userAndCompany!: { user: UserInterface, company: CompanyInterfaceExtended };
    apiService!: ApiService;
  
    companyEureso$:BehaviorSubject<any> = new BehaviorSubject<any>({});
    userCompany$:BehaviorSubject<any> = new BehaviorSubject<any>({});
    user$: ReplaySubject<any> = new ReplaySubject<any>(1);
  
    companyFinancialStatements!: CompanyFinancialStatements;

    updateUserPromise: Promise<any> | null = null;
    updateUserInfoPromise: Promise<any> | null = null;

    constructor(
        // private apiOauthService: ApiOauthService,
        // private apiWpService: ApiWpService,
        private platformApiWpService: PlatformApiWpService,
        private tokenService: TokenService,
        private chartConfigService: ChartConfigService,
        private commonConfigService: CommonConfig
    ) {

        this.apiService = this.platformApiWpService;
        this.tokenService.loggedSignal.subscribe((logged: boolean) => {
          console.log('change in logged', logged);
          if (logged){
            this.retrieveUserCompany(true);
          }
        });
    }

    redirectToAdmin(): boolean | UrlTree {
      const url = this.commonConfigService.getFromConfig('adminUrl', '/wp-admin');
      
      window.location.href = window.location.origin.indexOf('localhost') > -1 ? 'https://servicecompany.maredigital.it/' + url : window.location.origin + '/' + url;
      return false
    }
    checkUserIsAdmin(user: any): boolean {
      if(!user)
        return false;
      const adminRoles = this.commonConfigService.getFromConfig('adminRoles', ['administrator', 'msc_administrator_role', 'msc_operator_role', 'msc_intermediator_role']);
      const userRoles = user?.roles || [];
      const intersected = userRoles.filter((role: string) => {
        return adminRoles.indexOf(role) !== -1;
      });
      if(intersected.length > 0) {
        return true;
      }
      // if(adminRoles.includes(user.role)) {
      //   return true;
      // }
      return false;
    }

    retrieveUserCompany(forceReload?: boolean): Promise<any> {
      if (!forceReload && this.retriveUserCompanyPromise) {
          return this.retriveUserCompanyPromise;
      }
      this.retriveUserCompanyPromise = new Promise<any>((resolve, reject) => {

      // qui controlliamo se c'è la company nel session storage e nel cas la trovassimo la risolviamo e evitiamo una nuova chiamata
      // let userAndCompanyInStrorage = this.getUserCompanyFromStorage();

          if (!forceReload && this.userAndCompany) {
            resolve(this.userAndCompany);
              setTimeout(() => {
                  this.retriveUserCompanyPromise = null;
              }, 50);
              return;
          }
          
          // else if (userAndCompanyInStrorage && Object.keys(userAndCompanyInStrorage).length == 2) {
          //   resolve(userAndCompanyInStrorage);
          //   this.userAndCompany = userAndCompanyInStrorage;
          //   this.companyEureso$.next(userAndCompanyInStrorage.company);
          //   this.userCompany$.next(userAndCompanyInStrorage);
          //     setTimeout(() => {
          //         this.retriveUserCompanyPromise = null;
          //     }, 50);
          //     return;
          // }

          if(!this.tokenService.isLogged()){
            resolve(null);
            // sessionStorage.removeItem('company');
            // sessionStorage.removeItem('user');
              setTimeout(() => {
                  this.retriveUserCompanyPromise = null;
              }, 50);
              return;
          }

        this.apiService.getRequest('msc/v1/userAndCompanyInfo').then((sub: any) => {
          sub.pipe(
                // take(1),  
                catchError((err: any) => {
                    reject(err);
                    setTimeout(() => {
                        this.retriveUserCompanyPromise = null;
                    }, 50);
                    return err;
                })
              )
              .subscribe((data: any) => {
                  if (data?.payload)
                      data = data.payload;
                  this.userAndCompany = data;
                  let user = data.user;
                // if (user) {
                //   this.setUserInStorage(user);
                // }
                this.user$.next(user);
                let company_summary = data.company.eureso_overview;
                if (company_summary) {
                  console.log('company_summary _____________', company_summary);
                  this.companyEureso$.next(company_summary);
                  // this.setCompanyInStorage(company_summary);
                }
                  resolve(data);
                  setTimeout(() => {
                      this.retriveUserCompanyPromise = null;
                  }, 50);
                  this.userCompany$.next(data);
              });
          })
      });
      return this.retriveUserCompanyPromise;
    }

    
    updateUser(params: any, preventShowLoader: boolean = false): Promise<any> {
      if (this.updateUserPromise){
        return this.updateUserPromise;
      }

      this.updateUserPromise =  new Promise<any>((resolve, reject) => {
       
        this.apiService.postRequest('msc/v1/updateUser', params, false, preventShowLoader).then((sub: any) => {
          sub
            .pipe(
              catchError((err: any) => {
                reject(err);
                setTimeout(() => {
                  this.updateUserPromise = null
                }, 50);
                return err;
              })
            )
            .subscribe((data: any) => {
              if (data && data.payload){
                data = data.payload;
                this.userAndCompany = data;
              }
              setTimeout(() => {
                this.updateUserPromise = null
              }, 50);
              resolve(data);
            });
        });
      });

      return  this.updateUserPromise;

  }


    updateMultipleUserCompanyInfo(params: any, preventShowLoader: boolean = false): Promise<any> {
      if (this.updateUserInfoPromise){
        return this.updateUserInfoPromise;
      }

      this.updateUserInfoPromise =  new Promise<any>((resolve, reject) => {
       
        this.apiService.postRequest('msc/v1/updateMultipleUserInfo', params, false, preventShowLoader).then((sub: any) => {
          sub
            .pipe(
              catchError((err: any) => {
                reject(err);
                setTimeout(() => {
                  this.updateUserInfoPromise = null
                }, 50);
                return err;
              })
            )
            .subscribe((data: any) => {
              if (data && data.payload){
                data = data.payload;
                this.userAndCompany = data;
              }
              setTimeout(() => {
                this.updateUserInfoPromise = null
              }, 50);
              resolve(data);
            });
        });
      });

      return  this.updateUserInfoPromise;

  }

    updateUserCompanyInfo(userMeta: string, metaValue: any): Promise<any> {
        if (this.updateUserInfoPromise){
          return this.updateUserInfoPromise;
        }
  
        this.updateUserInfoPromise =  new Promise<any>((resolve, reject) => {
          let body:any = {
            meta: userMeta,
            value: metaValue
          }
         
          this.apiService.postRequest('msc/v1/updateUserInfo', body, false,true).then((sub: any) => {
            sub
              .pipe(
                catchError((err: any) => {
                  reject(err);
                  setTimeout(() => {
                    this.updateUserInfoPromise = null
                  }, 50);
                  return err;
                })
              )
              .subscribe((data: any) => {
                if (data && data.payload){
                  data = data.payload;
                  this.userAndCompany = data;
                }
                setTimeout(() => {
                  this.updateUserInfoPromise = null
                }, 50);
                resolve(data);
              });
          });
        });
  
        return  this.updateUserInfoPromise;
  
    }
  
  getUserCompanyInfo(): Promise<any> {
    return new Promise<any>((resolve) => {
      if (this.userAndCompany) {
        resolve(this.userAndCompany);
      } else {
        this.retrieveUserCompany().then((data) => {
          this.userAndCompany = data;
          resolve(this.userAndCompany)
        });
      }
    });
  }

  getUserCompanyFromStorage() {
    const email = this.tokenService.getUserEmailToken();
    let data:any = {};
    const saved_email = sessionStorage.getItem('email_saved');
    if (!email || !saved_email || email.trim().toLocaleLowerCase() != saved_email.trim().toLocaleLowerCase()) {
      return null;
    }
    let company_summary = sessionStorage.getItem('company');
    if (company_summary) {
       data.company = JSON.parse(company_summary);
     }

    let user = sessionStorage.getItem('user');
    if (user) {
      data.user = JSON.parse(user);
    }
    return data;
  }

  setCompanyInStorage(company_summary: any) {
    const email = this.tokenService.getUserEmailToken();
    sessionStorage.setItem('email_saved', email);
    sessionStorage.setItem('company', JSON.stringify(company_summary));
  }

  setUserInStorage(user: any) {
    const email = this.tokenService.getUserEmailToken();
    sessionStorage.setItem('email_saved', email);
    sessionStorage.setItem('user', JSON.stringify(user));
  }

  setVisitedPageInStorage(visitedPage: string) {
    let visited = sessionStorage.getItem('visited_page');
    if (visited && !visited.includes(visitedPage)) {
      visited += (visited ? ',' : '') + visitedPage;
      sessionStorage.setItem('visited_page', visitedPage);
    } else {
      sessionStorage.setItem('visited_page', visitedPage);
    }
  }

  buildCompanyProfitsLossData(): Promise<any> {
		return new Promise((resolve, reject) => {
      if (this.companyFinancialStatements && Object.keys(this.companyFinancialStatements).length > 0) {
        console.log('financial statements ____________ ', this.companyFinancialStatements);
        resolve(this.companyFinancialStatements);
        return;
      }
      
      // let mycompany = this.userAndCompany.company.eureso_overview.companySummary.businessName;
      let company_eureso = this.userAndCompany.company.eureso_overview;
			// todo gestire il caso delle partite iva che non hanno salesforce
			if (!company_eureso.localFinancialStatements) {
				reject({ type: 'missing_balances', message: 'No data available' });
				return;
			}
			
			let fatturatoAzienda = company_eureso.localFinancialStatements[0].profitAndLoss.totalValueOfProduction;
			//azienda
			let ebitda = company_eureso.localFinancialStatements[0].profitAndLoss.ebitda;
			
			let profittabilitaAzienda = (ebitda / fatturatoAzienda) * 100;

			let ateco = company_eureso?.companySummary?.mainActivity?.code;
			if (ateco) {
				const data = this.chartConfigService.retrieveChartOverview(ateco);
				this.chartConfigService.makeChartOverviewApiCall(data).then((response: any) => {
					// sub.pipe(takeUntil(this.unsubscribe)).subscribe((response: any) => {
					console.log('responseeeee_------', response);
					let uidchart = 'UUID-DSHB-d9646f1f-37e6-45fc-87ec-150ed5ed17d6';
					if (!response?.payload) {
						reject({ type: 'missing_balances', message: 'No data available' });
						return;
					}
          
					let findResult = response?.payload?.find((el: any) => el?.graphicInfo.id === uidchart);
					if (!findResult ) {
						reject({ type: 'missing_chart', message: 'No config available' });
						return;
          }
        
          let fatturatoMedioMercato = findResult.result[0]?.fatturatoMedio ?? 0;
          let molMedio = findResult.result[0]?.molMedio ?? 0;
          let profittabilitaMercato = molMedio && fatturatoMedioMercato ? (molMedio / fatturatoMedioMercato) * 100 : 0;
          let utilePerso = fatturatoAzienda && profittabilitaMercato ? (fatturatoAzienda * profittabilitaMercato / 100 ) - ebitda : 0;
          this.companyFinancialStatements = {
            ebitda: ebitda,
            fatturatoAzienda: fatturatoAzienda,
            fatturatoMedio: fatturatoMedioMercato,
            profittabilitaAzienda: profittabilitaAzienda,
            profittabilitaMercato: profittabilitaMercato,
            utilePerso:utilePerso,
            chartconfig: findResult
          }

          resolve (this.companyFinancialStatements)

				
					// this.utileAziendaInveceDi = fatturatoAzienda * profittabilitaMercato;
					// if (fatturatoMedioMercato) {
					// 	this.potentialProfittabilityAzienda = fatturatoAzienda * this.profittabilitaMercato / 100
					// 	this.utilePerso = this.potentialProfittabilityAzienda - this.ebitda;
						
					// 	// let profitsValuetf = `${isPositiveOrNegtive}${deltaRos.toFixed(2)}%`;
					// 	this.profitsValueDiff = ((profittabilitaAzienda / this.profittabilitaMercato - 1) * 100).toFixed(2);
					// 	this.profitsValueDiff = Math.abs(this.profitsValueDiff);
					// 	console.log(profittabilitaAzienda, this.profittabilitaMercato);
					// 	this.lostProfitsValues = [
					// 		{
					// 			id: "ros",
					// 			rosfor: "Profittabilità azienda",
					// 			value: 0

					// 		},
					// 		{
					// 			id: "costs",
					// 			rosfor: "Profittabilità media di mercato",
					// 			value: 0

					// 		}]
					// 	let diffvalue = fatturatoAzienda - fatturatoMedioMercato
					// 	// if (diffvalue < 0) {
					// 	this.lossesOrProfits = fatturatoAzienda > 0 ? losses_profits.profits : losses_profits.losses;
					// 	// }
					// 	this.lostProfits = this.currencyPipe.transform(diffvalue, 'EUR');
					// 	this.graphicDataOverview = this.buildRosChart(this.lostProfitsValues, this.lostProfits, [Math.min(profittabilitaAzienda, this.profittabilitaMercato) > 0 ? 0 : Math.min(profittabilitaAzienda, this.profittabilitaMercato), Math.max(profittabilitaAzienda, this.profittabilitaMercato)]);
					// 	this.overviewready$.set(true);
					// 	resolve([profittabilitaAzienda, this.profittabilitaMercato])

					// }
					
				},
					(err) => {
						console.log(err);
					})
			}
		})//end of promise

	}
    
}